import { Box } from '@chakra-ui/react'
import { useAuth } from '../context/AuthContext'
import { redirectToLogout } from '../hooks/useAccount'

import { User } from '../icons'
import { MenuGroup, MenuItem } from './Menu'

export const BaseMenu = () => {
  const { user } = useAuth() ?? {}

  return (
    <Box
      sx={{
        display: { base: 'none', xl: 'grid' },
        width: '100%',
        gridAutoFlow: 'column',
        justifyContent: 'end'
      }}
      className="site-menu-wrapper"
    >
      <MenuGroup>
        <li>
          <MenuItem to="/profile">
            <User color="secondary.300" />
            {user?.userFullName}
          </MenuItem>
        </li>
        <li>
          <MenuItem as={'div'} onClick={() => redirectToLogout()}>
            Odhlásit se
          </MenuItem>
        </li>
      </MenuGroup>
    </Box>
  )
}
